import { createContext } from 'react';
import type { KameleoonState, UpdateKameleoonFeaturesList } from './types';

type KameleoonContextProps = {
    state: KameleoonState;
    updateFeaturesList: UpdateKameleoonFeaturesList;
};

export const KameleoonFeaturesContext = createContext<KameleoonContextProps>({
    state: { status: 'loading' },
    updateFeaturesList: () => undefined,
});
